import { render, staticRenderFns } from "./OrgUnitFilters.vue?vue&type=template&id=390d6dff"
import script from "./OrgUnitFilters.vue?vue&type=script&lang=js"
export * from "./OrgUnitFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports